import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import FormHelperText from '@mui/material/FormHelperText';
import IconButton from '@mui/material/IconButton';

import { copyToClipboard } from '../../utils';
import { VpIcon, useVpSnackbar } from '../';

const copyIconStyle = {
  position: 'absolute',
  right: '2px',
  bottom: '20px'
};

const getInputAdornment = (adornment, position) =>
  adornment ? (
    <InputAdornment position={position}>
      {typeof adornment === 'string' ? (
        <Typography variant="inputAdornment">{adornment}</Typography>
      ) : (
        adornment
      )}
    </InputAdornment>
  ) : null;

export const VpInput = ({
  label = '',
  name = '',
  value = '',
  canCopy = false,
  maxLength = undefined,
  startIcon = '',
  disableHelperText = false,
  smallLabel = false,
  isUppercase = false,
  startAdornment = null,
  ...rest
}) => {
  const { addSnackbarInfo } = useVpSnackbar();
  const handleCopy = async (e) => {
    e.stopPropagation();
    e.preventDefault();

    await copyToClipboard(value);

    addSnackbarInfo({ message: 'Copied text to clipboard' });
  };

  const id = `vp-input-${name}`;
  const inputStartAdornment = getInputAdornment(startAdornment, 'start');

  const inputValue =
    value && typeof value === 'string' && isUppercase ? value.toUpperCase() : value;

  const adornmentProps = {
    ...(startIcon
      ? {
          startAdornment: (
            <InputAdornment position="start">
              <VpIcon icon={startIcon} />
            </InputAdornment>
          )
        }
      : {}),
    ...(canCopy
      ? {
          endAdornment: (
            <InputAdornment position="end" sx={copyIconStyle}>
              <IconButton aria-label="Copy text to clipboard" onClick={handleCopy}>
                <VpIcon icon="Copy" />
              </IconButton>
            </InputAdornment>
          )
        }
      : {})
  };

  return (
    <FormControl fullWidth variant="outlined">
      {label &&
        (typeof label === 'string' ? (
          <Typography htmlFor={id} variant={smallLabel ? 'inputLabelSmall' : 'inputLabel'}>
            {label}
          </Typography>
        ) : (
          label
        ))}
      <OutlinedInput
        size="small"
        id={id}
        {...(value ? { value: inputValue } : {})}
        startAdornment={inputStartAdornment}
        inputProps={{
          maxLength
        }}
        {...adornmentProps}
        {...rest}
      />
      {!disableHelperText && <FormHelperText id={`${id}-helper-text`}>&nbsp;</FormHelperText>}
    </FormControl>
  );
};

VpInput.propTypes = {
  value: PropTypes.string,
  canCopy: PropTypes.bool,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  name: PropTypes.string,
  maxLength: PropTypes.number,
  startIcon: PropTypes.string,
  disableHelperText: PropTypes.bool,
  smallLabel: PropTypes.bool,
  isUppercase: PropTypes.bool,
  startAdornment: PropTypes.oneOfType([PropTypes.node, PropTypes.string])
};

export default VpInput;



// WEBPACK FOOTER //
// ./src/vp-ui/inputs/VpInput.jsx